var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quicksearch-widget"},[_c('quick-search-first-auto',{attrs:{"monthlyPrice":true,"widget":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }